import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=d62c4cf6&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d62c4cf6')) {
      api.createRecord('d62c4cf6', component.options)
    } else {
      api.reload('d62c4cf6', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=d62c4cf6&", function () {
      api.rerender('d62c4cf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2YvQfb82U5jMh/JS/comp/ImgFallback2.vue"
export default component.exports